import { LANDING_PATH } from "Common/constant";
import { getResumeStep, getResumeRoute, isPathwayDone } from "Common/pathwayResume";

export const canActivateGetStarted = ({ childProps }) => {
  if (childProps.location.from == undefined) {
    return { isAllowed: false, redirectUrl: LANDING_PATH };
  } else {
    return { isAllowed: true };
  }
};

export const canActivateB2BVerfication = ({ childProps }) => {
  if (!childProps.location.data?.mode) {
    return { isAllowed: false, redirectUrl: "/guest-user/login" };
  } else {
    return { isAllowed: true };
  }
};

export const canActivateCheckOtp = ({ childProps }) => {
  if (
    !childProps.location.data?.mode ||
    childProps.location?.data == undefined
  ) {
    return { isAllowed: false, redirectUrl: "/guest-user/login" };
  } else {
    return { isAllowed: true };
  }
};

export const canActivatePathway = ({ sltdProfile, pathname, childProps }) => {
  if (!sltdProfile || sltdProfile.org_type !== "corporate") {
    return { isAllowed: false, redirectUrl: "/guest-user/login" };
  }

  if (sltdProfile.is_profile_completed) {
    return { isAllowed: false, redirectUrl: "/logged-in-user/dashboard" };
  }

  // Onboarding finished but the tab was closed before "Proceed to Dashboard":
  // go to the dashboard and let Gatekeeper flag the profile complete.
  if (isPathwayDone(sltdProfile.pathways)) {
    return {
      isAllowed: false,
      redirectUrl: "/logged-in-user/dashboard",
      completeProfile: true,
    };
  }

  // Direct loads (pasted URL, new tab) arrive without a gate pass, so send the
  // user to their first unfinished step instead of restarting at language.
  const resumeStep = getResumeStep(sltdProfile.pathways);
  const resumePath = `/logged-in-user/${getResumeRoute(resumeStep)}`;
  // "Back" from care intro deliberately revisits language selection
  const isBackToLanguage =
    pathname === "/logged-in-user/select-language" &&
    childProps?.location?.from === "care-info";
  const allow = pathname === resumePath || isBackToLanguage;
  return {
    isAllowed: allow,
    redirectUrl: allow ? null : resumePath,
    state: allow ? undefined : { hasGatePass: true, resumePage: resumeStep?.page },
  };
};

export const canActivateSelectLanguage = ({ sltdProfile }) => {
  if (sltdProfile?.is_profile_completed) {
    return { isAllowed: false, redirectUrl: "/guest-user/login" };
  } else {
    return { isAllowed: true };
  }
};

export const GatekeeperService = {
  "/guest-user/getStarted": canActivateGetStarted,
  "/guest-user/B2B-verification": canActivateB2BVerfication,
  "/guest-user/check-otp": canActivateCheckOtp,
  "pathway-checker": canActivatePathway,
  "/logged-in-user/select-language": canActivatePathway,
  "/logged-in-user/care-intro": canActivatePathway,
  "/logged-in-user/pathway-process": canActivatePathway,
  "/logged-in-user/select-your-plan": canActivatePathway,
};
